import React from "react";
import DashboardFilter from "./DashboardFilter";
import DeliveryListSummary from "./DeliveryListSummary";
import globalConstants from "../shared/appConfig/globalConstants";

/**
 * Delivery List toolbar (Figma): row 1 = title + search + filter; row 2 = helper copy.
 * Rendered as MUI DataTable `title` so it stays one visual block (no split title/actions columns).
 */
const DeliveryListTableTitle = ({
	heading = globalConstants.Dashboard.DeliveryListHeading,
	applyFilters,
	onSearch,
	clearSearch,
	filterStatusString,
	resetFilters,
}) => {
	return (
		<div className="delivery-list-table-title">
			<div className="delivery-list-table-title__row1">
				<h6 className="delivery-list-table-title__heading">{heading}</h6>
				<DashboardFilter
					tableTitleGrid
					applyFilters={applyFilters}
					onSearch={onSearch}
					clearSearch={clearSearch}
					filterStatusString={filterStatusString}
					resetFilters={resetFilters}
				/>
			</div>
			<DeliveryListSummary />
		</div>
	);
};

export default DeliveryListTableTitle;
